import { useRef } from "react";
import {
  motion,
  useAnimationFrame,
  useMotionValue,
  useScroll,
  useSpring,
  useTransform,
  useVelocity,
  wrap,
} from "framer-motion";
import { Reveal } from "@/components/Reveal";

const WORDS = ["DESIGN.", "DEVELOP.", "OPTIMISE.", "CREATE.", "LAUNCH."];

const VelocityRow = ({ baseVelocity = 2.2 }) => {
  const baseX = useMotionValue(0);
  const { scrollY } = useScroll();
  const scrollVelocity = useVelocity(scrollY);
  const smoothVelocity = useSpring(scrollVelocity, { damping: 50, stiffness: 400 });
  const velocityFactor = useTransform(smoothVelocity, [0, 1000], [0, 3.5], { clamp: false });
  const x = useTransform(baseX, (v) => `${wrap(-25, 0, v)}%`);
  const direction = useRef(1);

  useAnimationFrame((t, delta) => {
    let moveBy = direction.current * baseVelocity * (delta / 1000);
    const vf = velocityFactor.get();
    if (vf < 0) direction.current = -1;
    else if (vf > 0) direction.current = 1;
    moveBy += direction.current * moveBy * Math.abs(vf);
    baseX.set(baseX.get() + moveBy);
  });

  const copy = (
    <div className="flex shrink-0 items-baseline whitespace-nowrap" aria-hidden="true">
      {WORDS.map((w, i) => (
        <span
          key={`${w}-${i}`}
          className={`font-display font-extrabold uppercase tracking-tighter text-[17vw] lg:text-[10rem] leading-none px-5 lg:px-8 ${
            i % 2 ? "text-outline" : "text-neutral-100"
          }`}
        >
          {w}
        </span>
      ))}
    </div>
  );

  return (
    <div className="overflow-hidden">
      <motion.div className="flex w-max" style={{ x }}>
        {copy}
        {copy}
        {copy}
        {copy}
      </motion.div>
    </div>
  );
};

export const Marquee = () => (
  <section data-testid="marquee-typography-section" className="relative py-28 lg:py-40 overflow-hidden border-t border-white/5">
    <VelocityRow />
    <Reveal className="text-center mt-16 lg:mt-24 px-5">
      <p className="font-display italic text-xl sm:text-2xl text-neutral-400 tracking-tight">
        From first idea to final pixel.
      </p>
    </Reveal>
  </section>
);
